/* ============================================================
   <clic-why-clic> — "Why switch to CliC" tabbed feature explainer
   Paired with sections/section-why-clic.liquid

   - Desktop: tabs (vertical list) swap the photo + detail panel;
     prev/next arrows cycle features.
   - Mobile: an accordion renders the same features (own markup branch
     in the section); opening an item selects its feature (photo
     crossfade included), tapping the open item collapses it.
   - Panel photos render lazily; an IntersectionObserver flips them
     to eager just before the section scrolls into view so tab
     switches don't pop in.
   ============================================================ */
(function () {
  'use strict';
  if (customElements.get('clic-why-clic')) return;

  class ClicWhyClic extends HTMLElement {
    connectedCallback() {
      if (this._init) {
        if (this.io) this.io.observe(this);
        return;
      }
      this._init = true;

      this.tabs = Array.prototype.slice.call(this.querySelectorAll('.clic-why__tab'));
      this.panels = Array.prototype.slice.call(this.querySelectorAll('.clic-why__panel'));
      this.images = Array.prototype.slice.call(this.querySelectorAll('.clic-why__image'));
      this.accItems = Array.prototype.slice.call(this.querySelectorAll('.clic-why__acc-item'));
      this.current = 0;

      var self = this;
      this.tabs.forEach(function (t) {
        t.addEventListener('click', function () { self.select(+t.dataset.feature); });
        t.addEventListener('keydown', function (e) { self.onTabKey(e, t); });
      });
      Array.prototype.forEach.call(this.querySelectorAll('.clic-why__acc-btn'), function (b) {
        b.addEventListener('click', function () { self.toggleAcc(+b.dataset.feature); });
      });
      Array.prototype.forEach.call(this.querySelectorAll('.clic-why__arrow'), function (a) {
        a.addEventListener('click', function () { self.step(+a.dataset.dir); });
      });

      // preload panel photos just before the section is reached
      if ('IntersectionObserver' in window) {
        this.io = new IntersectionObserver(function (entries) {
          if (entries.some(function (e) { return e.isIntersecting; })) {
            self.eagerLoad();
            self.io.disconnect();
            self.io = null;
          }
        }, { rootMargin: '400px 0px' });
        this.io.observe(this);
      } else {
        this.eagerLoad();
      }

      // theme editor: follow block selection
      if (window.Shopify && window.Shopify.designMode) {
        this._onBlockSelect = function (e) {
          var id = e.detail && e.detail.blockId;
          if (!id) return;
          var tab = self.tabs.filter(function (t) {
            return t.dataset.blockId && id.indexOf(t.dataset.blockId) !== -1;
          })[0];
          if (tab) self.select(+tab.dataset.feature);
        };
        document.addEventListener('shopify:block:select', this._onBlockSelect);
      }
    }

    eagerLoad() {
      this.images.forEach(function (wrap) {
        Array.prototype.forEach.call(wrap.querySelectorAll('img[loading="lazy"]'), function (img) {
          img.loading = 'eager';
        });
      });
    }

    // mobile accordion: opening an item selects the feature; tapping the
    // open one collapses it (the photo keeps showing that feature)
    toggleAcc(i) {
      if (isNaN(i)) return;
      var item = this.accItems[i];
      if (item && i === this.current && item.classList.contains('is-active')) {
        this.setAccOpen(i, false);
        return;
      }
      this.select(i);
    }

    setAccOpen(i, open) {
      var item = this.accItems[i];
      if (!item) return;
      item.classList.toggle('is-active', open);
      var btn = item.querySelector('.clic-why__acc-btn');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    select(i) {
      if (isNaN(i) || i < 0 || i >= this.tabs.length) return;
      this.current = i;
      this.tabs.forEach(function (t, idx) {
        var on = idx === i;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
      });
      this.panels.forEach(function (p, idx) {
        var on = idx === i;
        if (on) p.removeAttribute('hidden'); else p.setAttribute('hidden', '');
        p.classList.toggle('is-active', on);
      });
      this.images.forEach(function (im, idx) {
        var on = idx === i;
        im.classList.toggle('is-active', on);
        if (on) im.removeAttribute('aria-hidden'); else im.setAttribute('aria-hidden', 'true');
      });
      var self = this;
      this.accItems.forEach(function (item, idx) {
        self.setAccOpen(idx, idx === i);
      });
      // a shown image no longer waits for scroll (covers pre-IO tab taps)
      this.eagerLoad();
    }

    step(dir) {
      var n = this.tabs.length;
      this.select((this.current + dir + n) % n);
    }

    onTabKey(e, tab) {
      var horiz = e.key === 'ArrowRight' || e.key === 'ArrowLeft';
      var vert = e.key === 'ArrowDown' || e.key === 'ArrowUp';
      if (!horiz && !vert) return;
      e.preventDefault();
      var fwd = e.key === 'ArrowRight' || e.key === 'ArrowDown';
      var idx = this.tabs.indexOf(tab);
      var next = fwd ? (idx + 1) % this.tabs.length : (idx - 1 + this.tabs.length) % this.tabs.length;
      this.tabs[next].focus();
      this.select(next);
    }

    disconnectedCallback() {
      if (this.io) this.io.disconnect();
      if (this._onBlockSelect) document.removeEventListener('shopify:block:select', this._onBlockSelect);
    }
  }

  customElements.define('clic-why-clic', ClicWhyClic);
})();
